var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"vh-100 d-flex flex-column justify-content-center align-items-center"},[_c('img',{staticClass:"img-fluid",attrs:{"width":"500","src":require("../../assets/img/404.jpg"),"alt":"Responsive image"}}),_c('p',{staticClass:"py-4 h1"},[_vm._v(_vm._s(_vm.$t("page-not-found.title")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }